import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4c3d30e0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  id: "Comment"
};
var _hoisted_2 = {
  key: 0,
  class: "banner-title"
};
var _hoisted_3 = {
  class: "banner-title"
};
var _hoisted_4 = {
  key: 1,
  class: "no-comment"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$commentInfo$comm;

  var _component_CommentItem = _resolveComponent("CommentItem");

  var _component_Loading = _resolveComponent("Loading");

  var _component_Pagination = _resolveComponent("Pagination");

  return _openBlock(), _createElementBlock(_Fragment, null, [(_ctx$commentInfo$comm = _ctx.commentInfo.comments) !== null && _ctx$commentInfo$comm !== void 0 && _ctx$commentInfo$comm.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.commentInfo.hotComments ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 热门评论(" + _toDisplayString(_ctx.commentInfo.hotComments.length) + ") ", 1
  /* TEXT */
  )) : _createCommentVNode("v-if", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentInfo.hotComments, function (hot, index1) {
    return _openBlock(), _createBlock(_component_CommentItem, {
      commentItem: hot,
      key: index1
    }, null, 8
    /* PROPS */
    , ["commentItem"]);
  }), 128
  /* KEYED_FRAGMENT */
  )), _createElementVNode("div", _hoisted_3, "最新评论(" + _toDisplayString(_ctx.commentInfo.total) + ")", 1
  /* TEXT */
  ), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentInfo.comments, function (New, index2) {
    return _openBlock(), _createBlock(_component_CommentItem, {
      commentItem: New,
      key: index2
    }, null, 8
    /* PROPS */
    , ["commentItem"]);
  }), 128
  /* KEYED_FRAGMENT */
  ))])) : _ctx.commentInfo.total == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无评论数据~")) : (_openBlock(), _createBlock(_component_Loading, {
    key: 2
  })), _createCommentVNode(" 分页器 "), _ctx.pageInfo.limit < _ctx.commentInfo.total ? (_openBlock(), _createBlock(_component_Pagination, {
    key: 3,
    pageInfo: _ctx.pageInfo,
    total: _ctx.commentInfo.total,
    curtPage: _ctx.curtpage,
    onChangeCurrent: _ctx.changeCurrent
  }, null, 8
  /* PROPS */
  , ["pageInfo", "total", "curtPage", "onChangeCurrent"])) : _createCommentVNode("v-if", true)], 64
  /* STABLE_FRAGMENT */
  );
}